<template>
   <div class="gallery">
       <div class="image" v-for="img in images" :style="{backgroundImage:`url(${img.src})`}">
         
       </div>
   </div>
</template>

<script>
    export default {
      name:"gallery",
       data(){
        return {
          images:[
            {name:"",src:"http://www.karatau.kazatomprom.kz/sites/default/files/styles/photorep/public/gallery/700a0926.jpg"},
            {name:"",src:"http://www.karatau.kazatomprom.kz/sites/default/files/styles/photorep/public/gallery/700a0146_0.jpg"},
            {name:"",src:"http://www.karatau.kazatomprom.kz/sites/default/files/styles/photorep/public/gallery/700a0167_0.jpg"},
            {name:"",src:"http://www.karatau.kazatomprom.kz/sites/default/files/styles/photorep/public/gallery/700a0516.jpg"},
            {name:"",src:"http://www.karatau.kazatomprom.kz/sites/default/files/styles/photorep/public/gallery/700a0905.jpg"},
            {name:"",src:"http://www.karatau.kazatomprom.kz/sites/default/files/styles/photorep/public/gallery/700a0895.jpg"},
            {name:"",src:"http://www.karatau.kazatomprom.kz/sites/default/files/styles/photorep/public/gallery/700a0886.jpg"},
            {name:"",src:"http://www.karatau.kazatomprom.kz/sites/default/files/styles/photorep/public/gallery/700a0865.jpg"},
            {name:"",src:"http://www.karatau.kazatomprom.kz/sites/default/files/styles/photorep/public/gallery/700a0820.jpg"},
          ]
        }
       }
    }
</script>

<style scoped>

</style>